import { Injectable } from '@angular/core';
import { ApiDirectory } from '@core/api/api-directory';
import { RequestResponse } from '@core/services/request/model/request.model';
import { RequestService } from '@core/services/request/request.service';
import { Observable } from 'rxjs';
import { LoadingIds } from '@shared/constants/loading';
import { ReportModelApi } from '@core/api/model/consumption-invoices/consumption-invoices-api.model';

@Injectable({
  providedIn: 'root',
})
export class ApiInformesUserService {
  constructor(private _requestService: RequestService) {}

  public fetchInformesUser(genericLoading?: boolean): Observable<RequestResponse<Array<ReportModelApi>>> {
    return this._requestService.get<RequestResponse<Array<ReportModelApi>>>(ApiDirectory.ConsumoInformes.InformesUser({}), {
      loading: genericLoading ?? LoadingIds.FETCH_INFORMES_CONSUMPTION,
    });
  }

  /**
   * Fetch an report given its report code
   */
  public unloadReport(code: string, genericLoading?: boolean): Observable<Blob> {
    return this._requestService.download(ApiDirectory.ConsumoInformes.UnloadReport({ codigo: code }), {
      loading: genericLoading ?? LoadingIds.FETCH_INFORMES_CONSUMPTION,
    });
  }
}
